import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'worry-tree-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    'worry-tree--client-selector': {
      width: '250px',
    },
    'worry-tree--input': {
      width: '80%',
      marginBottom: '20px',
    },
    'fading-container': {
      animation: 'fadeIn ease 2s',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
    },
    'worry-tree--buttons-container': {
      display: 'flex',
      maxWidth: '250px',
      width: '200px',
      justifyContent: 'space-between',
    },
    'worry-tree--image-title': {
      margin: '20px 0',
    },
  };
});
export default useStyles;
